import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import IFrame from "./IFrame";
import CmsSliderOverlay from "./CmsSliderOverlay";
import ScrollToTop from "./ScrollToTop";

export default function Layout() {
  return (
    <div className="relative Layout">
      <ScrollToTop />
      <CmsSliderOverlay />
      <IFrame />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

// {Popup code for form when website loads it will show the form popup}

// import { useEffect, useState } from "react";
// import { Outlet } from "react-router-dom";
// import Footer from "./Footer";
// import Header from "./Header";
// import IFrame from "./IFrame";
// import CmsSliderOverlay from "./CmsSliderOverlay";
// import ScrollToTop from "./ScrollToTop";
// import Form from "./Form"; // ✅ adjust this path if needed

// const HIDE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

// export default function Layout() {
//   const [showPopup, setShowPopup] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   useEffect(() => {
//     const lastSubmitted = localStorage.getItem("form-popup-submitted");

//     // Show popup if never submitted or 24 hours have passed
//     if (!lastSubmitted || Date.now() - Number(lastSubmitted) > HIDE_DURATION) {
//       const timeout = setTimeout(() => {
//         setShowPopup(true);
//       }, 2000); // 3 seconds delay

//       return () => clearTimeout(timeout);
//     }
//   }, []);


//   const handleFormSubmit = () => {
//     localStorage.setItem("form-popup-submitted", Date.now().toString());
//     setSubmitted(true);

//     // Optionally auto-close after 3 seconds
//     setTimeout(() => {
//       setShowPopup(false);
//     }, 3000);
//   };

//   return (
//     <div className="relative isolate Layout">
//       {showPopup && (
//         <div className="fixed inset-0 z-[9999] bg-black bg-opacity-60 flex justify-center items-center px-2 sm:px-4">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-[980px] max-h-[95vh] overflow-y-auto p-4 sm:p-6 relative">
//             <button
//               onClick={() => setShowPopup(false)}
//               className="absolute top-2 right-3 text-gray-500 text-4xl sm:text-2xl z-10"
//             >
//               &times;
//             </button>

//             <div className="pt-6 sm:pt-6">
//               {submitted ? (
//                 <div className="text-center py-6">
//                   <h2 className="text-lg sm:text-xl font-bold">🎉 Thank you!</h2>
//                   <p className="text-gray-600 mt-2 text-sm sm:text-base">
//                     We’ve received your info.
//                   </p>
//                 </div>
//               ) : (
//                 <div className="flex flex-col items-center justify-center text-center">
//                   <h2 className="text-[#ea2339] text-2xl sm:text-3xl font-bold mb-0 relative -top-6">
//                     Request a quotation
//                   </h2>
//                   <Form onSubmit={handleFormSubmit} showPrivacyNotice={true} />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       <ScrollToTop />
//       <CmsSliderOverlay />
//       <IFrame />
//       <Header />
//       <main>
//         <Outlet />
//       </main>
//       <Footer />
//     </div>
//   );
// }
